import { useCartContext } from "context/cart-context";
import { MESSAGES_TYPES } from "./constants";

export const useParseErrorMessage = ({ brandName }) => {
  const {
    cart: { errorMessage },
    clearErrorMessage
  } = useCartContext();

  const getErrorByCartErrorMessage = () => {
    const parsedErrorMessage = String(errorMessage).toLowerCase();
    switch (!!parsedErrorMessage) {
      case parsedErrorMessage.includes("$10,000"):
        return MESSAGES_TYPES[2](errorMessage);
      case parsedErrorMessage.includes("more than 25"):
        return MESSAGES_TYPES[0];
      case parsedErrorMessage.includes("we no longer have"):
        return MESSAGES_TYPES[1](brandName);
      default:
        return null;
    }
  };

  return {
    error: getErrorByCartErrorMessage(),
    handleCloseModal: clearErrorMessage
  };
};
